import 'es6-promise/auto'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment  from 'moment';
//import './registerServiceWorker.js';


import Editor from '@tinymce/tinymce-vue'
import tinycolor from 'tinycolor2'


import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.use(VueLodash, { lodash: lodash })


import $ from 'jquery';
global.$ = $;
import 'bootstrap';
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


Vue.use(Editor);
library.add(fas, far)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
import 'datatables.net';
import 'datatables.net-bs4';

$.extend($.fn.dataTable.defaults,
    {
       
        "language": {

            "sEmptyTable": "Nessun elemento trovato",
            "sInfo": "Vista da _START_ a _END_ di _TOTAL_ elementi",
            "sInfoEmpty": "Vista da 0 a 0 di 0 elementi",
            "sInfoFiltered": "(filtrati da _MAX_ elementi totali)",
            "sInfoPostFix": "",
            "sInfoThousands": ".",
            "sLengthMenu": "Visualizza _MENU_ elementi",
            "sLoadingRecords": "Caricamento...",
            "sProcessing": "Elaborazione...",
            "sSearch": "Cerca:",
            "sZeroRecords": "La ricerca non ha portato alcun risultato.",
            "oPaginate": {
                "sFirst": "Inizio",
                "sPrevious": "Precedente",
                "sNext": "Successivo",
                "sLast": "Fine"
            },
            "oAria": {
                "sSortAscending": ": attiva per ordinare la colonna in ordine crescente",
                "sSortDescending": ": attiva per ordinare la colonna in ordine decrescente"
            }
        }

    }
);




import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

import axios from 'axios'

import axiosConfig from './axios';


//import i18n from './i18n';

//import VeeValidateIT from 'vee-validate/dist/locale/it';
//import VeeValidate, { Validator } from 'vee-validate';

//Vue.use(VeeValidate, {
//  events: 'change'
//});


//VeeValidateIT.messages.date_format = function (field, f) { return `Il campo ${field} non riconosciuto.`; }
//Validator.localize('it', VeeValidateIT);

import { ValidationProvider } from 'vee-validate';



Vue.component('ValidationProvider', ValidationProvider);


//fragment per evitare di mettere un div nel template
import { Fragment } from 'vue-fragment';
Vue.component('fragment', Fragment);


import editableLabel from './components/EditableLabel/Label.vue';
Vue.component('EditableLabel', editableLabel);


import notelist from './components/Note/input.vue';
Vue.component('notelist', notelist);


import * as VueGoogleMaps from "vue2-google-maps";

import gmap from './components/GMap/Input.vue';
Vue.component('gmap', gmap);
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);

import emailaddress from './components/EmailAddress/Input.vue';
import emailaddresslist from './components/EmailAddress/List.vue';
Vue.component('EmailAddress', emailaddress);
Vue.component('EmailAddressList', emailaddresslist);

import website from './components/WebSite/Input.vue';
import websitelist from './components/WebSite/List.vue';
Vue.component('website', website);
Vue.component('websitelist', websitelist);


import phone from './components/Phone/Input.vue';
import phonelist from './components/Phone/List.vue';
Vue.component('phone', phone);
Vue.component('phonelist', phonelist);

import fax from './components/Fax/Input.vue';
import faxlist from './components/Fax/List.vue';
Vue.component('fax', fax);
Vue.component('faxlist', faxlist);



import taglist from './components/Tag/Input.vue';
import tags from './components/Tag/list.vue';
Vue.component('taglist', taglist);
Vue.component('tags', tags);

import noresult from './components/NoResult/404.vue';
Vue.component('noresult', noresult);


import attachments from './components/Attachments/input.vue';
Vue.component('attachments', attachments);

import bankinformation from './components/Bank/save.vue';
Vue.component('bankinformation', bankinformation);

import oneinformation from './components/One/save.vue';
Vue.component('oneinformation', oneinformation);

import callList from './components/Call/list.vue';
Vue.component('callList', callList);


import orderList from './components/Orders/list.vue';
Vue.component('orderList', orderList);


import sidebar from './components/UserFilters/sidebar.vue';
Vue.component('sidebarUserFilter', sidebar);

import mailmessagelist from './components/MailMessage/List.vue';
Vue.component('mailmessagelist', mailmessagelist);

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
Vue.component('vueDropzone', vue2Dropzone);


import { localize } from 'vee-validate';
//import it from 'vee-validate/dist/locale/it.json';
import { extend } from 'vee-validate';

import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/it.json';
import it from 'vee-validate/dist/locale/it.json';
import VueCurrencyFilter from 'vue-currency-filter'

import Avatar from 'vue-avatar'
Vue.component('Avatar', Avatar);


import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule], // copies rule configuration
        message: messages[rule] // assign message
    });
});

// Install and Activate the Arabic locale.
localize('it', it);
import { configure } from 'vee-validate';
configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
});
extend('required', {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});
Vue.config.productionTip = false;

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
    }
});

Vue.filter('formatFullDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm:ss');
    }
});

if(VueCurrencyFilter){
Vue.use(VueCurrencyFilter,
    {
      symbol : '€',
      thousandsSeparator: '.',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'front',
      symbolSpacing: true,
      avoidEmptyDecimals: undefined,
    })
}

Vue.filter('state', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `${window.SETTINGS.states[value].description}`
    }
    return "";
});

Vue.filter('stateCss', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `${window.SETTINGS.states[value].cssClass}`
    }
    return "";
});

Vue.filter('stateTextCss', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
        return `text-${window.SETTINGS.states[value].cssClass}`
    }
    return "";
});

Vue.filter('statebadge', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.states && window.SETTINGS.states[value]) {
      
        return `<span class="badge badge-${window.SETTINGS.states[value].cssClass}">${window.SETTINGS.states[value].description}</span>`
      
    }
    return "";
});

window.TagTypeCss = function (color) {
    var allColors = [];
    for (var i in tinycolor.names) {
        allColors.push(i);
    }
    var mostReadable = tinycolor.mostReadable(color, allColors);

    var retval = "";

    retval += "border-color: " + tinycolor(color).darken(30).toHexString() + "!important;";
    retval += "background-color:" + tinycolor(color).toHexString() + ";";
    retval += "color: " + mostReadable.toHexString() + ";";

    return retval;
}
Vue.filter('tagtypecss', function (color) {

    return window.TagTypeCss(color);
   
});

Vue.filter('formatHour', function (value) {
    if (value) {
        return moment(String(value)).format('HH:mm');
    }
});

Vue.filter('formatFullDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm');
    }
});

Vue.filter('formatStatsDate', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM');
    }
});

Vue.filter('duration',function(value){
    return moment.utc(value*1000).format('HH:mm:ss');
})

Vue.filter('toCurrency', function (value) {
   
    return "€ " + value.toFixed(2).replace('.',',');
});

Vue.filter('toNumber', function (value) {
   
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});
Vue.filter('attachemntUrl', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.attachmentUrl) {
        return `${window.SETTINGS.attachmentUrl}/${value}`;
    }
    return "#";
});
Vue.filter('documentUrl', function (value) {
    if (value && window.SETTINGS && window.SETTINGS.documentUrl) {
        return `${window.SETTINGS.documentUrl}/${value}`;
    }
    return "#";
});
Vue.filter('attachemntTempUrl', function (value, o) {
    if (value && window.SETTINGS && window.SETTINGS.attachmentUrl) {
        return `${window.SETTINGS.attachmentUrl}?filename=${value}&originalFileName=${o}`;
    }
    return "#";
   
});

Vue.filter('slugify', function(value){
    return value.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');
});
Vue.prototype.$filters = Vue.options.filters;

window.EditAction = function (evt) { }
window.RemoveAction = function (evt) { }

window.SETTINGS = {
    "apiUrl": "http://localhost:5000/api",
    "GMAPKEY": "AIzaSyBHNuAXn1vxtNI7TAk6aup5xtOIoANzy6w",
    "attachmentUrl": "http://localhost:5000/attachment",
    "roles": ["administrator", "developer", "user", "agent"],
  
}


switch (process.env.NODE_ENV) {
    case 'production':
        axios.get('settings').then(result => {
            Object.assign(window.SETTINGS, result.data);
            axiosConfig();
            Mount();
        }).catch()
        break;

    default:
        axios.get('http://localhost:5000/settings').then(result => {
            Object.assign(window.SETTINGS, result.data);
            axiosConfig();
            Mount();
        }).catch()
        axiosConfig();
        Mount();
        break;
}


function Mount() {
    Vue.use(VueGoogleMaps, {
        load: {
            key: window.SETTINGS.GMAPKEY
        },


    });
   
      


mountApp();
   
}

function mountApp(){
    setTimeout(()=>{
        if(document.getElementById("app")){
        new Vue({
            router,
            store,
            //i18n,
            render: h => h(App)
        }).$mount('#app');
    } else mountApp();
    },500)

}
